import { Component, OnInit } from '@angular/core';
import {HttpCustomService} from "../../../service/http-custom.service";
import {API} from "../../../shared/apis/api";
import {CommonConstants} from "../../../shared/constants/common-constants.enum";
import {RoleTypeEnum} from "../../../shared/constants/role-type.enum";
import {Router} from "@angular/router";

@Component({
  selector: 'omni-home-page',
  templateUrl: './home-page.component.html'
})
export class HomePageComponent implements OnInit {

  constructor(
    private httpCustomService: HttpCustomService,
    private router: Router
  ) { }
  numberOfCooperative: number;
  numberOfStation: number;
  numberOfCustomer: number;
  cooperativeNo: number;

  ngOnInit(): void {
    const cooperativeNo = localStorage.getItem(CommonConstants.USER_COOPERATIVE_NO);
    const customerNo = localStorage.getItem(CommonConstants.CUSTOMER_NO);
    const stationNo = localStorage.getItem(CommonConstants.STATION_NO);
    const roleType = localStorage.getItem(CommonConstants.ROLE_TYPE);
    if (roleType === RoleTypeEnum.USER) {
      this.router.navigateByUrl(`/meter-cooperative/cooperative/${cooperativeNo}/station/${stationNo}/customer/${customerNo}`).finally();
    }
    this.httpCustomService.get({path: API.COOPERATIVE_OVERVIEW}).subscribe(res => {
      if (res) {
        this.numberOfCooperative = res.numberOfCooperative;
        this.numberOfStation = res.numberOfStation;
        this.numberOfCustomer = res.numberOfCustomer;
        this.cooperativeNo = res.cooperativeNo;
      }
    })
  }

}
